/**
 * Styles and Dimensions Constants
 * Contains dimensions, sizes, colors, donut styles, and other visual constants
 */

export enum DIMENSIONS {
  width = 'width',
  height = 'height',
}

export enum HEIGHT {
  fourteenPixels = '40px',
}

export enum SELECTOR_STYLES {
  DefaultWidth = '250px',
  DefaultTitleColor = '#330072',
  DefaultTitleWidth = '175px',
  DefaultBackgrounColor = 'rgba(100, 41, 205, 0.08)',
  DefaultContainerWidth = 'auto',
  DefaultContainerContentMaxHeight = '250px',
  DefaultContainerContentWidth = 'max-content',
  DefaultContainerContentMaxWidth = '300px',
  DefaultIndex = 0,
}

export const PHOTO_SIZE = '28px';
export const SMALL_HEIGHT = '40px';
export const PERCENT_100 = '100%';
export const AUTO = 'auto';
export const PX = 'px';
export const DEFAULT_MESSAGE_WIDTH = '420px';

export const SEPARATOR_SMALL_SIZE = 'small';
export const SEPARATOR_LARGE_SIZE = 'large';
export const SEPARATOR_DARK_THEME = 'dark';
export const SEPARATOR_LIGHT_THEME = 'light';
export const SEPARATOR_SIMPLE_THEME = 'simple';

export enum SEPARATOR_SIZES {
  Small = 'small',
  Large = 'large',
}

export enum SEPARATOR_THEME {
  Light = 'light',
  Dark = 'dark',
}

export enum Colors {
  red = 'red',
  orange = 'orange',
  yellow = 'yellow',
  yellowgreen = 'yellowgreen',
  green = 'green',
  disable = 'disable',
}

export enum DonutStyles {
  COLOR_COMPLETE = '#00ECA5',
  COLOR_PROGRESS = '#6429CD',
  TRAIL_COLOR_PROGRESS = '#F3EEFB',
  EASE_IN_OUT = 'easeInOut',
  URL_SVG = 'http://www.w3.org/2000/svg',
  TYPE_GRADIENT = 'svg',
  MESSAGE_ERROR_SVG = 'No SVG element found',
  ID_FILTER = 'drop-shadow',
  URL_FILTER = 'url(#drop-shadow)',
  URL_GRADIENT = 'url(#gradient-progress)',
  COLOR_STOKE_FINALIZED = 'rgba(0, 236, 165, 1)',
  ID_GRADIENT = 'gradient-progress',
  COLOR_GRADIENT_1 = '#8A8AFF',
  PERCENTAGE_COLOR_1 = '19.99%',
  COLOR_GRADIENT_2 = '#824de2',
  PERCENTAGE_COLOR_2 = '62.67%',
  COLOR_GRADIENT_3 = '#BB65FF',
  PERCENTAGE_COLOR_3 = '82.52%',
}

export enum DonutAssessmentConstants {
  DONUT_SIZE = '133px',
  DONUT_BORDER_RADIUS = '50%',
  PERCENTAGE_MAX = 100,
  PERCENTAGE_MAX_DECIMAL = 1,
  PERCENTAGE_MIN = 0,
  STROKE_WIDTH_DEFAULT = 20,
}

export const POINTS_CIRCLE_DIAMETER = 39.29;
export const POINTS_MIN_FONT_SIZE_ONE_OR_TWO_DIGITS = 16;
export const POINTS_MIN_FONT_SIZE_FOUR_DIGITS = 10;
export const POINTS_FONT_SIZE_MULTIPLIER = 0.8;
export const POINTS_DEFAULT_CLASS = 'big';
export const POINTS_DEFAULT_TOTAL_POINTS = 0;

export const TRANSPARENT_STRING = 'transparent';
export const HIDDEN_TEXT = 'hidden';
export const SPACE_IN_PIXELES_FOR_TEXTAREA = 6;

export const EVENTS = {
  DOCUMENT: 'document',
  MOUSEDOWN: 'mousedown',
  MOUSEUP: 'mouseup',
  MOUSEMOVE: 'mousemove',
};

export const PROPERTIES_REFERENCES = {
  actualAssessment: 'actualAssessment',
  actualAutoassessment: 'actualAutoassessment',
  additionalComments: 'additionalComments',
  blur: 'blur',
  chapterName: 'chapterName',
  documentClick: 'document:click',
  eventTarget: '$event.target',
  focus: 'focus',
  inputLink: 'inputLink',
  id: 'id',
  modal: 'modal',
  scroll: 'scroll',
  senioritiesInfo: 'senioritiesInfo',
  stepsContainer: 'stepsContainer',
  visibilitychange: 'visibilitychange',
  competence: 'competence',
} as const;
